import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Works from '../views/Works.vue'
import Episodes from '../views/Episodes.vue'
import Revenue from '../views/Revenue.vue'
import Copyright from '../views/Copyright.vue'
import WithdrawInfo from '../views/WithdrawInfo.vue'
import WithdrawRecords from '../views/WithdrawRecords.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { title: '数据看板', requiresAuth: true }
      },
      {
        path: 'works',
        name: 'works',
        component: Works,
        meta: { requiresAuth: true }
      },
      {
        path: 'episodes',
        name: 'episodes',
        component: Episodes,
        meta: { requiresAuth: true }
      },
      {
        path: 'revenue',
        name: 'revenue',
        component: Revenue,
        meta: { requiresAuth: true }
      },
      {
        path: 'copyright',
        name: 'copyright',
        component: Copyright,
        meta: { requiresAuth: true }
      },
      {
        path: 'withdraw/info',
        name: 'withdrawInfo',
        component: WithdrawInfo,
        meta: { requiresAuth: true }
      },
      {
        path: 'withdraw/records',
        name: 'withdrawRecords',
        component: WithdrawRecords,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/register',
    redirect: to => {
      // 重定向到登录页面，并传递邀请码参数
      return { path: '/login', query: { invite: to.query.invite } }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login')
  } else if (to.matched.some(record => record.meta.guest) && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
